module.exports = __webpack_public_path__ + "logo-dark.png?3ba06d72e9cdfc5c267c0e005a7f90da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark/logo-dark.png
// module id = 956
// module chunks = 2